// @ts-nocheck
import { call, put } from 'redux-saga/effects';
import {
  transactionsDownloadRequest,
  transactionsDownloadFailure,
  transactionsDownloadSuccess,
} from '../reducer/transactionsDownloadSlice';
import { downloadTransactions } from '../api';

export function* handleTransactionsDownload(action) {

  const {
    accountId,
    customerId,
    cycleDate = '',
    selectedFileType = '',
    isRefresh = false,
    recaptchaToken
  } = action.payload || {};
  if (!accountId || !customerId) {
    yield put(transactionsDownloadFailure('Missing parameters'));
    return;
  }

  try {
   // yield put(transactionsDownloadRequest());

    const apiresponse = yield call(
      downloadTransactions,
      'downloadTransactions',
      accountId,
      customerId,
      cycleDate,
      selectedFileType,
      recaptchaToken,
      isRefresh
    );
    const response = apiresponse?.responseBody;
    console.log("here@@",response,apiresponse?.statusCode);
if(apiresponse?.statusCode == 200){
    const blob = new Blob([response], {
      type: selectedFileType === 'OFX' ? 'application/x-ofx' : 'text/csv',
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download =
      selectedFileType === 'OFX' ? 'transactions.ofx' : 'transactions.csv';

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    yield put(transactionsDownloadSuccess());
  }else{
     yield put(transactionsDownloadFailure(response));
   }
  } catch (error) {
    console.error('Error downloading CSV', error);
    yield put(transactionsDownloadFailure(error.message));
  }

}
